import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import ServiceManager from "../3x1010/services/ServiceManager.js";
import {
  initExploreOnScroll,
  initMapLightboxes
} from "../helpers/helpers.js";
import Nav from "./components/Nav.js";
import BlocksAccordion from "./blocks/BlocksAccordion.js";

export default class PageProduct extends PageCommon {
  constructor() {
    super();
    this.isHp = false;
  }

  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageProduct - Hello world");

    this.initActionBuy();
    this.initAccordions();
    this.initSwipers();
    this.initHeaderScroll();
    this.initRelatedProductsBlock();
    initExploreOnScroll(document.querySelectorAll(".js-section-explore"));
    initMapLightboxes();

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      console.log(error);
    }
  }

  get isHomepage() {
    return this.isHp;
  }

  set isHomepage(bool) {
    this.isHp = bool;
  }

  initSwipers() {
    const swiperAwards = document.querySelector(".js-swiper-awards");
    if (!swiperAwards) return;

    let figure;
    const parent = swiperAwards.parentNode;
    const btnNext = parent.querySelector(".swiper-button-next");
    const btnPrev = parent.querySelector(".swiper-button-prev");
    const pagination = parent.querySelector(".swiper-pagination");

    const swiper = new Swiper(swiperAwards, {
      spaceBetween: 32,
      freeMode: true,
      grabCursor: true,
      autoplay: true,
      autoHeight: true,
      slidesPerView: 2,
      slidesPerGroup: 2,
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev
      },
      pagination: {
        el: pagination
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 16
        }
      },
      on: {
        afterInit: () => {
          figure = swiperAwards.querySelector("figure");
          if (!figure) return;

          swiperAwards
            .parentNode
            .style
            .setProperty(
              "--figure-h",
              `${Math.round(figure.offsetHeight)}px`
            );
        }
      }
    });

    if (!figure) return;

    let resizing;
    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing =
        setTimeout(() => {
          swiperAwards
            .parentNode
            .style
            .setProperty(
              "--figure-h",
              `${Math.round(figure.offsetHeight)}px`
            );
        });
    });
  }

  initRelatedProductsBlock() {
    const cards = document.querySelectorAll(".js-related-product-entry");
    let resizing;

    this.setRelatedProductsBodiesWidth(cards);
    window.addEventListener("resize", (e) => {
      clearTimeout(resizing);
      resizing = setTimeout(() => this.setRelatedProductsBodiesWidth(cards), 250);
    });
  }

  setRelatedProductsBodiesWidth(cards) {
    cards?.forEach((card) => {
      const body = card.querySelector(".js-related-product-body");
      const bottle = card.querySelector(".js-related-bottle");
      const figure = card.querySelector(".js-related-product-figure");
      if (!body || !bottle || !figure) return;

      body.style.setProperty("--w-subtract", `${Math.round(bottle.offsetWidth / 2 + figure.offsetWidth)}px`);
      body.style.setProperty("--bottle-w", `${Math.round(bottle.offsetWidth)}px`);
    });
  }

  initHeaderScroll() {
    const info = document.querySelector(".js-product-info");
    if (!info) return;

    window.addEventListener("scroll", this.handleHeaderScroll.bind(this, info));
  }

  handleHeaderScroll(info) {
    const threshold = window.innerHeight - Nav.navHeight;
    const y = window.scrollY;

    if (y >= threshold) {
      info.classList.remove("is-fixed");

      return;
    }

    !info.classList.contains("is-fixed")
      && info.classList.add("is-fixed");
  }

  initAccordions() {
    const blocksAccordion = new BlocksAccordion(this.handleAccordionOpen.bind(this));
    blocksAccordion.init();
  }

  handleAccordionOpen(payload) {
    return;
    const { target, open } = payload;
  }

  initActionBuy() {
    $('.js-buy').click((ev) => {
      const uid = $(ev.currentTarget).attr('data-puid');
      location.href = '/' + TheApp.Env.Locale + '/carrello?addUid=' + uid
    });
  }
}